<div class="form-group check-box-container mb-0" [ngClass]="{'has-error' : !control?.valid }">
    <span [ngbTooltip]="toolTipText ? toolTipText : ''" placement="top" container="body">
        <input *ngIf="!idField" #checbox type ="checkbox" class="formcontrol check-box-input" [formControl]="formCtrl" 
            (click)="changedEvent.emit(!control.value)" [attr.disabled]="disableCheckbox ? true : null"/>
    </span>
    <span [ngbTooltip]="toolTipText ? toolTipText : ''" placement="top" container="body">
        <input *ngIf="idField" #checbox type ="checkbox" class="formcontrol check-box-input" (change)="assignToControl($event)" 
            [attr.checked]="control.value && control.value.selected? true : null" [attr.disabled]="disableCheckbox ? true : null"/>
    </span>
    <label [attr.for] = "idName" [ngClass]="{'ml-2' : label != ''}">{{label}}</label>
    <div *ngIf="control?.errors?.required && control?.touched">
        {{label}}
    </div>
    <div class="text-danger" *ngIf="control?.errors?.defaultAlreadyExists && (control?.touched || externalTrigger)">
        {{label}} failed, default already exists
    </div>
    <div class="text-danger" *ngIf="control?.errors?.canDefaultBillToValidator && (control?.touched || externalTrigger)">
        {{label}} failed, default already exists
    </div>
    <div class="text-danger" *ngIf="control?.errors?.canDefaultShipToValidator && (control?.touched || externalTrigger)">
        {{label}} failed, default already exists
    </div>
</div>